export default __webpack_public_path__ + "static/media/infoPanelHighlight2.f0093632.png";